
































































import ModalOptions from '@/shared/modal/modal-options.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import SelectiveProcessService from '@/domain/selective-process/service/selective-process.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';

@Component({
  components: {
    ModalComponent,
    LabelSlot,
    ModalWarning,
  },
})
export default class ResetSurveyModal extends Vue {
  @Prop() openModal!: boolean;

  @Prop({
    type: String,
    required: true,
  }) surveyAnswerId!: string;

  @Prop({
    type: String,
    required: true,
  }) surveyName!: string;

  loading: boolean = false;

  reason: string = '';

  rules: Rules = new Rules();

  isValidForm: boolean = false;

  openConfirmModal: boolean = false;

  get optionsHandled(): ModalOptions {
    return {
      title: `Redefinir ${this.surveyName}`,
      titleSize: '20px',
      description: '',
      showOk: true,
      labelOk: 'continuar',
      okColor: 'primary',
      loadingOk: false,
      disabledOk: !this.isValidForm,
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 500,
    };
  }

  get modalWarningOptions(): ModalOptions {
    return {
      title: 'Você tem certeza?',
      titleSize: '20px',
      description: '',
      showOk: true,
      labelOk: 'Confirmar',
      okColor: 'error',
      loadingOk: this.loading,
      showCancel: !this.loading,
      labelCancel: 'Cancelar',
      width: 500,
    };
  }

  closeModal() {
    this.$emit('close');
  }

  async reset() {
    try {
      this.loading = true;
      await SelectiveProcessService.reset(this.surveyAnswerId, this.reason);
      VbSnackbarService.showSuccess(`O ${this.surveyName} foi redefinido com sucesso!`);
      this.openConfirmModal = false;
      this.$emit('reseted');
      this.closeModal();
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loading = false;
    }
  }
}
